import styled from 'styled-components'

import {
  backgroundTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  textTypes,
} from '../types'
import { background, boxModel, css, display, text } from '../util'

/**
 * @namespace Text
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Text = styled.p`
  ${background};
  ${boxModel};
  ${css};
  ${display};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Text
 * @desc Primitive's default properties
 */
Text.defaultProps = {
  fontSize: 'baseFontSize',
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Text
 * @desc Primitive's prop type definitions
 */
Text.propTypes = {
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...textTypes,
}

/** @component */
export default Text
